<button class="btn btn-lg btn-primary btn-block mt-2 text-white" (click)="redirectToOrcid()">
  <i class="fas fa-sign-in-alt"></i> {{"login.form.orcid" | translate}}
</button>